"use client";

import { useCallback, useState } from "react";
import { clearAuthSession, revokeCustomerSession } from "@/lib/auth-session";

export function useCustomerLogout() {
  const [isSigningOut, setIsSigningOut] = useState(false);

  const signOut = useCallback(async () => {
    if (isSigningOut) return;

    setIsSigningOut(true);
    try {
      await revokeCustomerSession();
      clearAuthSession();
      window.location.assign("/");
    } catch {
      window.alert("Sign out could not be confirmed. Please try again.");
      setIsSigningOut(false);
    }
  }, [isSigningOut]);

  return { isSigningOut, signOut };
}
